import React from 'react';
import C18Anchor00 from './C18Anchor00'
import {cl} from '../../components/utils/utils';

class C18SubMenuHeader00 extends React.Component{
  constructor(props) {
    super(props);
    this.state={
    }
  }
  
  onChange=(e,type,vals)=>{
    e.preventDefault()
    this.props.parms.onChange({pageType:type})//cmd:"idoserPage",
//     cl(type)
    
  }
  
  showItems=()=>{
//     cl(this.props)
    var makeRow=(first,last)=>{
      let row=[]
      for(let i=first;i<last;i++){
        let item=this.props.parms.items[i]
        let active=(item.v==this.props.parms.pageType || item.e==this.props.parms.pageType || item.l==this.props.parms.pageType)?"active":""
        if(!item.d){
          row.push(
            <td key={i}>
              <C18Anchor00 to="" key={i} className={active} disabled
                onClick={ev=>{this.onChange(ev,item.v)}}
              >{item.t}</C18Anchor00>
            </td>
          )
        }

      }
      return row
    }
    let len=this.props.parms.items.length
    let rows=[]
    for(let i=0;i<len;i+=8){
      let first=i
      let last=i+8
      if(last>len){last=len}
      rows.push(<tr key={i}>{makeRow(first,last)}</tr>)
    }
    return(
      <table style={{width:"100%"}}><tbody>
      {rows}
      </tbody></table>
    )

//     return this.props.parms.items.map((item,i)=>{
//       let active=(item.v==this.props.parms.pageType || item.e==this.props.parms.pageType || item.l==this.props.parms.pageType)?"active":""
//       if(item.d){}else{
//         return(
//           <C18Anchor00 to="" key={i} className={active} disabled
//             onClick={ev=>{this.onChange(ev,item.v)}}
//           >{item.t}</C18Anchor00>
//         )
//       }
//     })
  }
  
  
  render(){
    
    return(
        <nav className="subnav floatleft">
          {this.showItems()}
        </nav>
    )
  }
}
      
export default C18SubMenuHeader00;
